// Centralized currency constants
// Map of currency codes to their display symbols
export const SUPPORTED_CURRENCY_SYMBOLS = new Map<string, string>([
  ['USD', '$'], // US Dollar
  ['EUR', '€'], // Euro
  ['CRC', '₡'], // Costa Rican Colón
  ['GBP', '£'], // British Pound Sterling
  ['ILS', '₪'], // Israeli New Sheqel
  ['INR', '₹'], // Indian Rupee
  ['JPY', '¥'], // Japanese Yen
  ['KRW', '₩'], // South Korean Won
  ['NGN', '₦'], // Nigerian Naira
  ['PHP', '₱'], // Philippine Peso
  ['PLN', 'zł'], // Polish Zloty
  ['PYG', '₲'], // Paraguayan Guarani
  ['THB', '฿'], // Thai Baht
  ['UAH', '₴'], // Ukrainian Hryvnia
  ['VND', '₫'], // Vietnamese Dong
  ['ZAR', 'R'], // South African Rand
]);
